// View, print or download a PDF the API returned (quote, work order, invoice).
//
// One place for all three so every summary page behaves the same way:
//  - view: opens the PDF in a new tab (the long-standing behaviour).
//  - print: loads it into a hidden frame and opens the browser's print dialog, without
//    leaving the page. If the browser will not print from a frame, it falls back to a tab.
//  - download: saves it under a readable file name, e.g. "workorder_WO-1234.pdf".

export const PDF_ACTION = { VIEW: 'view', PRINT: 'print', DOWNLOAD: 'download' }

const POPUP_BLOCKED = 'Pop-up was blocked by your browser! Please allow pop-ups for caradasplus.com to view this document.'
// Long enough for the print dialog or download to take the file before its URL is released.
const RELEASE_AFTER_MS = 60 * 1000

const openInTab = (url) => {
  const pdfWindow = window.open()
  if (pdfWindow === null) {
    alert(POPUP_BLOCKED)
    return
  }
  pdfWindow.location.href = url
}

const download = (url, fileName) => {
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
}

const print = (url) => {
  const frame = document.createElement('iframe')
  frame.style.position = 'fixed'
  frame.style.width = '0'
  frame.style.height = '0'
  frame.style.border = '0'
  frame.setAttribute('aria-hidden', 'true')
  frame.onload = () => {
    try {
      frame.contentWindow.focus()
      frame.contentWindow.print()
    } catch (error) {
      openInTab(url)
    }
  }
  frame.src = url
  document.body.appendChild(frame)
  setTimeout(() => frame.remove(), RELEASE_AFTER_MS)
}

export const handlePdf = (pdfContent, fileName, action = PDF_ACTION.VIEW) => {
  const blob = new Blob([pdfContent], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)
  if (action === PDF_ACTION.DOWNLOAD) {
    download(url, fileName)
  } else if (action === PDF_ACTION.PRINT) {
    print(url)
  } else {
    openInTab(url)
  }
  setTimeout(() => URL.revokeObjectURL(url), RELEASE_AFTER_MS)
}
